(function () {
  const selectors = {
    video: '.media.media--video',
    videoControls: '.media__controls',
  };

  const videoNodes = document.querySelectorAll(selectors.video);
  if (videoNodes && videoNodes.length) {
    const videos = Array.from(videoNodes);
    videos.map((video) => {
      const videoNode = video.querySelector('video');
      const videoControls = video.querySelector(selectors.videoControls);
      if (videoNode && videoControls) {
        videoControls.addEventListener('click', (e) => {
          if (videoNode.paused) {
            videoNode.play();
            video.classList.remove('media--paused');
          } else {
            videoNode.pause();
            video.classList.add('media--paused');
          }
        });
      }
    });
  }
})();
